export const environment = {
    production: true,
    apiUrl: 'https://api.xpaxbooking.com/api/',
    bookingUrl: 'https://booking.xpaxbooking.com/',
    s3Url: 'https://d20miawm7utdli.cloudfront.net/',
    liffBooking: '2000012656-JZEVAMOq'
};
